import {
  DEFAULT_LOCALE,
  LOCALES,
  TranslationsProvider,
  getStrings,
  type Locale,
  type Translations,
} from "services/strings";
import { useRouter } from "next/router";
import { useMemo, type ReactNode } from "react";

export type PageTranslations = { locale: Locale; strings: Translations };

/**
 * Provides the page's strings: the ones the page passed in its props, or
 * else the router locale's, built synchronously so the server renders the
 * page with its text and head instead of an empty shell.
 */
export const TranslationsLoader = ({
  children,
  translations,
}: {
  children?: ReactNode;
  translations?: PageTranslations;
}) => {
  const { locale } = useRouter();
  const routerTranslations = useMemo(() => {
    const selected = LOCALES.includes(locale as Locale)
      ? (locale as Locale)
      : DEFAULT_LOCALE;
    return { locale: selected, strings: getStrings(selected) };
  }, [locale]);

  return (
    <TranslationsProvider {...(translations ?? routerTranslations)}>
      {children}
    </TranslationsProvider>
  );
};
